import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BicValidationModel } from "../models/bic-validation.model";

@Injectable({
   providedIn: "root"
})
export class BicService {
   private httpClient = inject(HttpClient);

   private readonly baseUri: string;
   private readonly endpoint: string;

   constructor() {
      this.baseUri = `https://openiban.com/validate`;
      this.endpoint = `getBIC=true&validateBankCode=true`;
   }

   public get(iban: string): Observable<BicValidationModel> {
      return this.httpClient.get<BicValidationModel>(
         `${this.baseUri}/${iban}?${this.endpoint}`
      );
   }
}
